// Single source of truth for module-based access control on the frontend.
// The backend returns each user's *effective* modules in `user.permissions`
// (role defaults, or per-user overrides). Admins implicitly have everything.

export type Role = "admin" | "principal" | "teacher" | "student" | "parent" | "cashier" | "examhead";

// Assignable modules (Dashboard is always available and not listed here).
export const MODULES: { key: string; label: string }[] = [
  { key: "students", label: "Students" },
  { key: "staff", label: "Staff" },
  { key: "users", label: "Users" },
  { key: "attendance", label: "Attendance" },
  { key: "cashier", label: "Collect Fees" },
  { key: "fees", label: "Fees" },
  { key: "exams", label: "Exams" },
  { key: "class_tests", label: "Class Tests" },
  { key: "academics", label: "Academics" },
  { key: "timetable", label: "Timetable" },
  { key: "notifications", label: "Notifications" },
];

// Route path -> module key.
export const ROUTE_MODULE: Record<string, string> = {
  "/students": "students",
  "/master-data": "master_data",
  "/staff": "staff",
  "/users": "users",
  "/attendance": "attendance",
  "/cashier": "cashier",
  "/fees": "fees",
  "/exams": "exams",
  "/class-tests": "class_tests",
  "/academics": "academics",
  "/timetable": "timetable",
  "/notifications": "notifications",
};

type UserLike = { role?: string | null; permissions?: string[] | null } | null | undefined;

export function canAccess(user: UserLike, path: string): boolean {
  const mod = ROUTE_MODULE[path];
  if (!mod) return true; // e.g. /dashboard — always available to authenticated users
  if (!user) return false;
  if (user.role === "admin") return true;
  return (user.permissions || []).includes(mod);
}
